import { UserContext } from "context";
import { useContext, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";

const PrivateRoute = ({ element }) => {
    const navigate = useNavigate();
    const { token } = useContext(UserContext)
    let isAuthenticated = token


    useEffect(() => {
        if (!isAuthenticated) {
            navigate("/");
        }
    }, [navigate, isAuthenticated, token])

    return isAuthenticated
        ? element
        : <Navigate to="/" />;
}

export default PrivateRoute